import { render, staticRenderFns } from "./VideoSeekTrim.vue?vue&type=template&id=36c3803a&"
import script from "./VideoSeekTrim.vue?vue&type=script&lang=js&"
export * from "./VideoSeekTrim.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeekTrim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports